import styled from "@emotion/styled";
import { InputLabel, Tab, Tabs } from "@mui/material";

export const TabsStyled = styled(Tabs)`
  margin-top: 24px;
  margin-bottom: 24px;
  display: flex;

  .MuiTabs-flexContainer {
    flex-direction: column;
    gap: 16px;
    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      flex-direction: row;
    }
  }

  .MuiButtonBase-root {
    color: ${({ theme }) => theme.colors.secondary.gray};
    text-transform: capitalize;
  }

  .Mui-selected {
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: 30px;
    color: ${({ theme }) => theme.colors.white} !important;
  }
`;

export const TabStyled = styled(Tab, {
  shouldForwardProp: prop => prop !== "hover",
})`
  min-width: 100%;
  border-radius: 30px;
  font-size: 16px;
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 18px;
    min-width: auto;
    padding: 18px 24px;
  }

  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    ${p =>
      p.hover &&
      `
        background-color: ${p.theme.colors.secondary.scroll};
      `}
  }
`;

export const WrapperTable = styled.div`
  margin-top: 24px;
`;
